export default __webpack_public_path__ + "static/media/ScanOnBoarding.fb82df1e.svg";